import { Divider, Grid } from "@material-ui/core";
import { SettingsIcon } from "../../shared/icons";
import { useStyles } from "./financial-profile.styles";
import { useHistory } from "../../shared/hooks/useHistory";

interface FinancialProfileFooterProps {
  handleClose: () => void;
  isMobile?: boolean;
}

export const FinancialProfileFooter = ({
  handleClose,
  isMobile,
}: FinancialProfileFooterProps) => {
  const classes = useStyles({});
  const history = useHistory();

  const handleRedirectTo = (path) => {
    handleClose();
    history.push(path);
  };

  return (
    <>
      <Grid container data-testid="footer-section">
        <Grid item lg={12}>
          <br />
          <Divider variant="middle" />
        </Grid>
        <Grid item lg={12} className={classes.footerActions}>
          {!isMobile && (
            <>
              <SettingsIcon
                onClick={() => handleRedirectTo("/participant/settings")}
              />
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

FinancialProfileFooter.defaultProps = {
  isMobile: false,
};
